import axiosInstance from "@/boot/axios";

class UserRepository {
    async paginatedSearch(search = "", page = 1, size = 25) {
        const response = await axiosInstance.get("/v1/user/", {
            params: {
                search,
                page,
                size,
            },
        });
        return response.data;
    }

    async updateStatus(userId, status) {
        await axiosInstance.put(`/v1/user/${userId}`, { status });
    }

    async updatePermissions(userId, permissions) {
        await axiosInstance.put(`/v1/user/${userId}`, { permissions });
    }
}

export default new UserRepository();
